/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useAsyncLoader } from "../../common-loader/hooks/useAsyncLoader";
import { useSubmitErrorToasts } from "../../common/hooks/useSubmitErrorToasts";
import { DataTestids } from "../../common/miscellaneous/DataTestids";
import { buildSetResult } from "../miscellaneous/buildSetResult";
import { useOrderValueData } from "./useOrderValueData";
import { useSetCountriesState } from "./useSetCountriesState";
import { useSetOrderState } from "./useSetOrderState";
import { useSetSettingsState } from "./useSetSettingsState";
import { useSetLookupPricingState } from "./useSetLookupPricingState";
import { useSetPhrasesAPIErrorState } from "../../common/miscellaneous/useSetPhrasesAPIErrorState";
import { useSetCountryAdministrativeAreasState } from "../../address/hooks/useSetCountryAdministrativeAreasState";

// eslint-disable-next-line @typescript-eslint/require-await
export const isAuthenticated = async () => true;

export function useInitializeCartState() {
  const loader = useAsyncLoader(DataTestids.LoaderUseInitializeCartState);
  useSubmitErrorToasts(loader);

  const order = useOrderValueData();
  const setOrder = useSetOrderState();
  const setSettings = useSetSettingsState();
  const setCountryList = useSetCountriesState();
  const setLookupPricing = useSetLookupPricingState();
  const setIsPhrasesAPIError = useSetPhrasesAPIErrorState();
  const setCountryAdministrativeAreas = useSetCountryAdministrativeAreasState();

  useEffect(() => {
    const setResult = buildSetResult(
      loader,
      order.data,
      setOrder,
      setSettings,
      setCountryList,
      setLookupPricing,
      setIsPhrasesAPIError,
      setCountryAdministrativeAreas
    );

    setResult();
  }, []);

  return loader;
}
